import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Palette } from "lucide-react";

import Navbar from "../../components/site/Navbar";
import Footer from "../../components/site/Footer";
import { useGarment } from "../../hooks/useGarment";

function formatPrice(garment) {
  const amount = Number(
    garment?.startingPrice ??
      garment?.basePrice ??
      garment?.fixedPrice ??
      0
  );

  if (!Number.isFinite(amount) || amount <= 0) {
    return "Price on request";
  }

  return `?${amount.toLocaleString("en-IN")}`;
}

export default function GarmentDetailPage() {
  const {
    categoryId,
    sectionId,
    garmentId,
  } = useParams();

  const navigate = useNavigate();

  const {
    garment,
    garmentLoading,
    garmentError,
  } = useGarment(garmentId);

  if (garmentLoading) {
    return (
      <div className="min-h-screen bg-[#FFF8F2]">
        <Navbar onBook={() => navigate("/#services")} />
        <main className="pt-32 pb-24">
          <div className="max-w-[1200px] mx-auto px-6 md:px-12">
            <div className="card-soft p-10 animate-pulse">
              <div className="h-10 bg-[#FFE7D2] rounded w-1/2" />
              <div className="h-6 bg-[#FFF0E3] rounded mt-5 w-1/3" />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (garmentError || !garment) {
    return (
      <div className="min-h-screen bg-[#FFF8F2]">
        <Navbar onBook={() => navigate("/#services")} />
        <main className="pt-32 pb-24">
          <div className="max-w-[900px] mx-auto px-6 md:px-12">
            <div className="card-soft p-10 text-center">
              <h1 className="font-display text-3xl">
                Garment could not be loaded
              </h1>

              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/category/${categoryId}/section/${sectionId}`
                  )
                }
                className="btn-primary mt-6"
              >
                Back to items
              </button>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const image =
    garment.mainImage ||
    garment.image ||
    garment.imageUrl ||
    "";

  return (
    <div className="min-h-screen bg-[#FFF8F2]">
      <Navbar onBook={() => navigate("/#services")} />

      <main className="pt-28 pb-24">
        <section className="max-w-[1200px] mx-auto px-6 md:px-12">
          <button
            type="button"
            onClick={() =>
              navigate(
                `/category/${categoryId}/section/${sectionId}`
              )
            }
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#F46524]"
          >
            <ArrowLeft size={16} />
            Back to items
          </button>

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div className="card-soft overflow-hidden bg-white">
              <div className="aspect-[4/5] bg-[#FFF3E8]">
                {image ? (
                  <img
                    src={image}
                    alt={garment.name}
                    className="w-full h-full object-contain object-center"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-[#F46524] font-semibold text-xl">
                    {garment.name}
                  </div>
                )}
              </div>
            </div>

            <div>
              <div className="font-label text-[#F46524] mb-4">
                StitchB Garment
              </div>

              <h1 className="font-display text-4xl md:text-6xl tracking-tight text-[#2B2B2B]">
                {garment.name}
              </h1>

              {garment.description ? (
                <p className="text-[#5b5a56] mt-6 text-lg leading-relaxed">
                  {garment.description}
                </p>
              ) : null}

              <div className="mt-8 text-3xl font-display text-[#F46524]">
                {formatPrice(garment)}
              </div>

              {garment.estimatedDays ? (
                <div className="mt-3 text-sm text-[#5b5a56]">
                  Estimated time: {garment.estimatedDays} day
                  {garment.estimatedDays === 1 ? "" : "s"}
                </div>
              ) : null}

              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/category/${categoryId}/section/${sectionId}/item/${garmentId}/designs`
                  )
                }
                className="btn-primary mt-10"
              >
                <Palette size={18} />
                Select Design
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

